import {
  MERCHANDISING,
  MRC_ACCESSORY,
  MRC_BUYER,
  MRC_BUYER_ADD,
  MRC_BUYER_EDIT,
  MRC_FABRIC,
  MRC_FABRIC_PART,
  MRC_GARMENT_ITEM,
  MRC_ITEM_CATEGORY,
  MRC_PROCESS,
  MRC_RATE_TYPE,
  MRC_SEASON,
  MRC_STYLE,
  MRC_TEAM,
} from '@constants/internal-route.constant'
import {IAppRoutes} from '@interface/common.interface'
import {guard} from './route-guard'

// Every screen is guarded by its own feature url (RequireFeature): a direct visit without the grant
// lands on LANDING. A missing guard would mean "always allow" — the menu alone hides nothing.
export const MerchandisingRoutes: IAppRoutes = {
  link: MERCHANDISING,
  childrens: [
    // Admin Config
    {link: MRC_TEAM, element: guard(() => import('@modules/merchandising/team'), [MRC_TEAM])},

    // Item Master Data
    {link: MRC_BUYER, element: guard(() => import('@modules/merchandising/buyer'), [MRC_BUYER])},
    {
      // add/edit are part of the Buyer feature: adding needs its Create, editing its Update
      link: MRC_BUYER_ADD,
      element: guard(() => import('@modules/merchandising/buyer/Form'), [MRC_BUYER], 'create'),
    },
    {
      link: MRC_BUYER_EDIT({id: ':id'}),
      element: guard(() => import('@modules/merchandising/buyer/Form'), [MRC_BUYER], 'update'),
    },
    {
      link: MRC_ITEM_CATEGORY,
      element: guard(() => import('@modules/merchandising/category'), [MRC_ITEM_CATEGORY]),
    },
    {
      link: MRC_FABRIC,
      element: guard(() => import('@modules/merchandising/item/Fabric'), [MRC_FABRIC]),
    },
    {
      link: MRC_ACCESSORY,
      element: guard(() => import('@modules/merchandising/item/Accessory'), [MRC_ACCESSORY]),
    },
    {link: MRC_STYLE, element: guard(() => import('@modules/merchandising/style'), [MRC_STYLE])},
    {
      link: MRC_SEASON,
      element: guard(() => import('@modules/merchandising/lookup/Season'), [MRC_SEASON]),
    },
    {
      link: MRC_GARMENT_ITEM,
      element: guard(() => import('@modules/merchandising/item/Garment'), [MRC_GARMENT_ITEM]),
    },
    {
      link: MRC_RATE_TYPE,
      element: guard(() => import('@modules/merchandising/lookup/RateType'), [MRC_RATE_TYPE]),
    },
    {
      link: MRC_FABRIC_PART,
      element: guard(() => import('@modules/merchandising/lookup/FabricPart'), [MRC_FABRIC_PART]),
    },
    {
      link: MRC_PROCESS,
      element: guard(() => import('@modules/merchandising/lookup/Process'), [MRC_PROCESS]),
    },
  ],
}
